<div class="externe-main flex-column" [class.externe-main-apps]="(externeAppsFacadeService.featurePermissions$ | async)?.length > 0">
  <div *ngIf="(externeAppsFacadeService.featurePermissions$ | async)?.length > 0" class="header">
    <button class="ep-btn ep-btn-primary btn-addLink" (click)="addExterneApp()" [disabled]="municipalityDeactivated$ | async">
      <app-svg-icon src="./assets/icons/ep_add.svg"></app-svg-icon>
      {{ 'module.userProfile.generalConfiguration.neueLinkApp' | translate }}
    </button>
  </div>
  <mat-card class="card externe-app-tab" [class.empty-state]="(externeAppsFacadeService.featurePermissions$ | async)?.length === 0">
    <mat-card-content>
      <div class="header-container borders-bottom ep-text-secondary-text">
        <label class="icon-label">{{ 'module.userProfile.generalConfiguration.icon' | translate }}</label>
        <label class="app-label">{{ 'module.userProfile.generalConfiguration.app' | translate }}</label>
        <label class="externer-link-label">{{ 'module.userProfile.generalConfiguration.externerLink' | translate }}</label>
        <label class="aktiviert-label">{{ 'module.userProfile.generalConfiguration.statusLabel' | translate }}</label>
        <label class="menu-label"></label>
      </div>
      <ng-container *ngIf="externeAppsFacadeService.featurePermissionStateIsLoading$ | async; then skeletonLoader; else loadingFinished"></ng-container>
    </mat-card-content>
  </mat-card>
</div>

<ng-template #skeletonLoader></ng-template>

<ng-template #loadingFinished>
  <div *ngIf="(externeAppsFacadeService.featurePermissions$ | async)?.length > 0; else empty" class="rows-container">
    <div
      *ngFor="let featurePermission of externeAppsFacadeService.featurePermissions$ | async"
      class="flex-row row-container borders-bottom ep-text-regular-16 ep-text-primary-text"
      [class.ep-text-disabled-text]="!featurePermission.isActive"
      [formGroup]="featurePermission.formGroup"
    >
      <div class="icon-label">
        <app-features-icon-app
          [icon]="featurePermission.iconName"
          [disabled]="!featurePermission.isActive || (municipalityDeactivated$ | async)"
        ></app-features-icon-app>
      </div>
      <div class="app-label text-ellipsis">{{ featurePermission.germanName }}</div>
      <div
        class="externer-link-label text-ellipsis"
        [class.text-ellipsis]="featurePermission.isGenericLink || featurePermission.municipalityPermissionsMappings?.length > 0"
      >
        <ng-container *ngIf="featurePermission.isGenericLink; else individualLink">
          <ng-container
            *ngTemplateOutlet="
              externalLink;
              context: { link: featurePermission.genericExternalURL, disabled: !featurePermission.isActive || (municipalityDeactivated$ | async) }
            "
          ></ng-container>
        </ng-container>
        <ng-template #individualLink>
          <app-externe-individual-link
            [externalLink]="featurePermission.municipalityPermissionsMappings[0]?.applicationURL"
            [disabled]="!featurePermission.isActive || (municipalityDeactivated$ | async)"
            (textchange)="changeExternalLink(featurePermission, $event)"
          ></app-externe-individual-link>
        </ng-template>
      </div>
      <div class="aktiviert-label">
        <mat-form-field appearance="outline" class="no-padding full-width">
          <mat-select
            panelClass="activation-selector"
            matNativeControl
            disableOptionCentering
            disableRipple
            formControlName="status"
            (selectionChange)="selectStatus($event.value, featurePermission)"
            [disabled]="!featurePermission.isActive || (municipalityDeactivated$ | async) || featurePermission.isDropdownDisabled"
          >
            <mat-option *ngFor="let appStatus of featurePermission.externeAppsStatus" [value]="appStatus.code" [disabled]="appStatus.disabled">{{
              appStatus.name
            }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="menu-label">
        <button
          [matMenuTriggerFor]="actionMenu"
          [matMenuTriggerData]="{ featurePermission: featurePermission }"
          (menuOpened)="menuOpened(featurePermission)"
          (menuClosed)="menuClosed()"
          class="ep-btn-dropdown-menu menu-button"
          [disabled]="!featurePermission.isActive || (municipalityDeactivated$ | async)"
        >
          <app-svg-icon src="./assets/icons/ep_menu-vertical.svg"></app-svg-icon>
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #empty>
  <div class="empty-state gap-24">
    <app-svg-icon src="./assets/icons/empty-state.svg"></app-svg-icon>
    <div class="empty-state-text">
      <div class="ep-text-regular-27 ep-text-tertiary-text">{{ 'module.userProfile.generalConfiguration.emptyTable.title' | translate }}</div>
      <div class="ep-text-regular-16 ep-text-tertiary-text" [innerHTML]="'module.userProfile.generalConfiguration.emptyTable.description' | translate"></div>
    </div>
    <button class="ep-btn ep-btn-primary btn-addLink" (click)="addExterneApp()" [disabled]="municipalityDeactivated$ | async">
      <app-svg-icon src="./assets/icons/ep_add.svg"></app-svg-icon>
      {{ 'module.userProfile.generalConfiguration.neueLinkApp' | translate }}
    </button>
  </div>
</ng-template>

<ng-template #externalLink let-externalLink="link" let-disabled="disabled">
  <a
    appReusableTooltip
    [href]="externalLink"
    [tooltip]="externalLink"
    target="_blank"
    class="ep-action-link ep-text-ellipsis ep-external"
    [class.disabled]="disabled"
    >{{ externalLink }}</a
  >
</ng-template>

<mat-menu #actionMenu="matMenu" class="externe-action-menu">
  <ng-template matMenuContent let-featurePermission="featurePermission">
    <button mat-menu-item disableRipple class="ep-text-primary-text" (click)="editExterneApp()">
      <span>{{ 'module.userProfile.generalConfiguration.actionMenu.edit' | translate }}</span>
    </button>
    <button mat-menu-item disableRipple class="ep-text-primary-text" (click)="deleteExterneApp()">
      <span>{{ 'module.userProfile.generalConfiguration.actionMenu.delete' | translate }}</span>
    </button>
  </ng-template>
</mat-menu>
